function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "263.013 45.004 263.013 40 248 40 248 45.004 253.004 45.004 253.004 55.013 248 55.013 248 60.017 263.013 60.017 263.013 55.013 258.009 55.013 258.009 45.004 263.013 45.004"
});

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "283.031 45.004 283.031 40 268.017 40 268.017 60.017 283.031 60.017 283.031 55.013 273.022 55.013 273.022 45.004 283.031 45.004"
});

var _ref5 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "288.035 40 288.035 60.017 293.039 60.017 293.039 55.013 298.044 55.013 298.044 50.009 293.039 50.009 293.039 45.004 298.044 45.004 298.044 50.009 303.048 50.009 303.048 40 288.035 40"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 302.5476,
  cy: 57.5153,
  r: 2.7524
});

var _ref7 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "41.822 50.842 50.982 50.842 50.982 49.201 41.822 49.201 41.822 41.672 51.598 41.672 51.598 40.031 39.996 40.031 39.996 60.031 51.793 60.031 51.793 58.391 41.822 58.391 41.822 50.842"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 55.9722,
  y: 45.0313,
  width: 1.748,
  height: 15
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M56.8608,39.9531a1.282,1.282,0,0,0-.913.3662,1.2052,1.2052,0,0,0,0,1.7676,1.3336,1.3336,0,0,0,1.8359,0,1.2054,1.2054,0,0,0,0-1.7676A1.2941,1.2941,0,0,0,56.8608,39.9531Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M71.2505,45.4658a5.4421,5.4421,0,0,0-2.6611-.63,5.1348,5.1348,0,0,0-2.7686.6983,4.2167,4.2167,0,0,0-1.6455,1.8506H64.019V45.0312H62.33v15h1.7383v-9.375A4.56,4.56,0,0,1,64.6,48.3955a3.6824,3.6824,0,0,1,1.45-1.46,4.2674,4.2674,0,0,1,2.1-.5078,3.6438,3.6438,0,0,1,2.7588,1.0743,4.0419,4.0419,0,0,1,1.03,2.92v9.6093h1.7382V50.3145a6.4018,6.4018,0,0,0-.64-2.9981A4.36,4.36,0,0,0,71.2505,45.4658Z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M96.3774,40.8467a7.1005,7.1005,0,0,0-3.5595-.8155H86.3628v20H88.189V52.3848h4.6582a7.053,7.053,0,0,0,3.5449-.8155,5.3335,5.3335,0,0,0,2.1484-2.2168,7.191,7.191,0,0,0-.0049-6.2939A5.3624,5.3624,0,0,0,96.3774,40.8467Zm.5762,7.69a3.78,3.78,0,0,1-1.5478,1.6162,5.2,5.2,0,0,1-2.6075.5908H88.189V41.6719h4.58a5.3118,5.3118,0,0,1,2.6319.5859,3.742,3.742,0,0,1,1.5527,1.6113,5.569,5.569,0,0,1,0,4.668Z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M109.1167,44.8066a4.6875,4.6875,0,0,0-2.5342.6983,3.7679,3.7679,0,0,0-1.5674,1.831h-.1269V45.0312h-1.6895v15h1.7383V50.3438a3.6927,3.6927,0,0,1,1.9678-3.3448,4.32,4.32,0,0,1,2.0849-.4931,4.8378,4.8378,0,0,1,.6348.039q.293.0388.41.0586V44.8359c-.1172-.0063-.2637-.0131-.4395-.02S109.26,44.8066,109.1167,44.8066Z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M121.792,45.8125a6.4716,6.4716,0,0,0-6.86-.0049,6.6106,6.6106,0,0,0-2.3291,2.7344,9.2853,9.2853,0,0,0-.84,4.0576,9.1747,9.1747,0,0,0,.84,4.0283,6.6582,6.6582,0,0,0,2.3291,2.73,6.466,6.466,0,0,0,6.8653,0,6.6574,6.6574,0,0,0,2.3291-2.73,10.1128,10.1128,0,0,0-.0049-8.081A6.6933,6.6933,0,0,0,121.792,45.8125Zm.8642,9.8633a5.2258,5.2258,0,0,1-1.6455,2.2363,4.5893,4.5893,0,0,1-5.2929,0,5.2258,5.2258,0,0,1-1.6455-2.2363,8.7324,8.7324,0,0,1,0-6.1621,5.27,5.27,0,0,1,1.65-2.2559,4.5389,4.5389,0,0,1,5.288,0,5.2883,5.2883,0,0,1,1.6455,2.2559,8.7324,8.7324,0,0,1,0,6.1621Z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M138.95,47.8926h-.1563a7.0239,7.0239,0,0,0-.85-1.3867,4.41,4.41,0,0,0-1.455-1.1963,4.8058,4.8058,0,0,0-2.2754-.4834,5.5507,5.5507,0,0,0-3.252.9717,6.3713,6.3713,0,0,0-2.1728,2.7148,11.0295,11.0295,0,0,0,0,8.13,6.4306,6.4306,0,0,0,2.163,2.7246,5.472,5.472,0,0,0,3.2325.9766,4.7933,4.7933,0,0,0,2.28-.4883,4.5253,4.5253,0,0,0,1.47-1.2061,6.8053,6.8053,0,0,0,.8593-1.4014h.2051v2.7832h1.6992v-20H138.95Zm-.5127,7.8662a4.9758,4.9758,0,0,1-1.5674,2.1973,4.2686,4.2686,0,0,1-5.0049-.0293,5.1257,5.1257,0,0,1-1.5673-2.2315,8.7844,8.7844,0,0,1-.5372-3.1543,8.6332,8.6332,0,0,1,.5323-3.1152,5.0347,5.0347,0,0,1,1.5625-2.2022,4.3415,4.3415,0,0,1,5.0244-.0293,4.8806,4.8806,0,0,1,1.5625,2.168,8.7376,8.7376,0,0,1,.5371,3.1787A8.8778,8.8778,0,0,1,138.4375,55.7588Z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M155.1807,54.2988a4.2042,4.2042,0,0,1-.6055,2.3194,4.0323,4.0323,0,0,1-1.543,1.4306,4.1721,4.1721,0,0,1-1.9531.4883,3.535,3.535,0,0,1-2.6562-1.0693,3.893,3.893,0,0,1-1.0352-2.8272V45.0312h-1.7383V54.748a6.4386,6.4386,0,0,0,.6348,2.9981,4.3917,4.3917,0,0,0,1.748,1.8506,5.0857,5.0857,0,0,0,2.5489.63,4.8977,4.8977,0,0,0,2.7929-.7666,4.6,4.6,0,0,0,1.67-1.919h.1368v2.49h1.7382v-15h-1.7382Z"
});

var _ref16 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "172.69 45.031 170.493 45.031 163.461 52.092 163.247 52.092 163.247 40.031 161.508 40.031 161.508 60.031 163.247 60.031 163.247 54.22 164.973 52.595 170.854 60.031 173.081 60.031 166.274 51.457 172.69 45.031"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M181.5371,58.5127a3.3586,3.3586,0,0,1-.5859.0439,2.7943,2.7943,0,0,1-1.1035-.22,1.7927,1.7927,0,0,1-.84-.7519,2.838,2.838,0,0,1-.3223-1.47v-9.57h3.1739V45.0312h-3.1739V41.4375h-1.748v3.5937h-2.2363v1.5137h2.2363v9.9805a3.4777,3.4777,0,0,0,2.0166,3.3105,4.2425,4.2425,0,0,0,1.8408.42,4.3051,4.3051,0,0,0,.918-.083,4.5241,4.5241,0,0,0,.625-.1807l-.3711-1.5723C181.8433,58.4526,181.7,58.4834,181.5371,58.5127Z"
});

var _ref18 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "198.812 57.736 198.676 57.736 194.223 45.031 192.338 45.031 197.816 60.031 199.672 60.031 205.15 45.031 203.266 45.031 198.812 57.736"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M217.25,45.8125a6.4716,6.4716,0,0,0-6.86-.0049,6.6106,6.6106,0,0,0-2.3291,2.7344,9.2853,9.2853,0,0,0-.84,4.0576,9.1747,9.1747,0,0,0,.84,4.0283,6.6582,6.6582,0,0,0,2.3291,2.73,6.466,6.466,0,0,0,6.8653,0,6.6574,6.6574,0,0,0,2.3291-2.73,10.1128,10.1128,0,0,0-.0049-8.081A6.6933,6.6933,0,0,0,217.25,45.8125Zm.8643,9.8633a5.2274,5.2274,0,0,1-1.6455,2.2363,4.5895,4.5895,0,0,1-5.293,0,5.2258,5.2258,0,0,1-1.6455-2.2363,8.7339,8.7339,0,0,1,0-6.1621,5.27,5.27,0,0,1,1.65-2.2559,4.5391,4.5391,0,0,1,5.2881,0,5.29,5.29,0,0,1,1.6455,2.2559,8.7339,8.7339,0,0,1,0,6.1621Z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M234.95,47.3164a4.36,4.36,0,0,0-1.7871-1.8506,5.4421,5.4421,0,0,0-2.6611-.63,5.1348,5.1348,0,0,0-2.7686.6983,4.2167,4.2167,0,0,0-1.6455,1.8506h-.1562V45.0312h-1.6895v15H225.98v-9.375a4.56,4.56,0,0,1,.5322-2.2607,3.6824,3.6824,0,0,1,1.45-1.46,4.2674,4.2674,0,0,1,2.1-.5078,3.6436,3.6436,0,0,1,2.7588,1.0743,4.0419,4.0419,0,0,1,1.03,2.92v9.6093h1.7383V50.3145A6.4018,6.4018,0,0,0,234.95,47.3164Z"
});

var SvgIcrPowered = function SvgIcrPowered(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    viewBox: "0 0 345 100",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcrPowered, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icr_powered.087e367b.svg";
export { ForwardRef as ReactComponent };